import { trackCdp, trackEvent, trackGA } from 'utilities/tracking';

window.Sq = window.Sq || {};
Sq.Shop = Sq.Shop || {};
$(() => Sq.Shop.CartIndex.init());

Sq.Shop.CartIndex = {
  utils: Sq.Shop.Utils,

  init() {
    if ($('#cart-page').length === 0) {
      return;
    }

    this.getHtml();
    this.getData();
    this.bindEvents();
    this.utils.trackCheckoutStep(this.$form, {
      index: 1,
      name: 'Review Cart',
    });
  },

  getHtml() {
    this.$form = $('.cart-update-form');
  },

  getData() {
    this.cartNumber = this.utils.cartNumber();
  },

  bindEvents() {
    this.$form.on('change', this.utils.QUANTITY_SELECTOR, (e) =>
      this.onCartUpdate(e)
    );
    this.$form.on('click', this.utils.REMOVE_SELECTOR, (e) =>
      this.onCartRemove(e)
    );
    this.$form.on('click', '.button', (e) => {
      this.utils.trackCheckoutClick(e.target, {
        event_desc: 'Cart: Check out clicked',
      });
    });
    $('#purchase-order').on('change', (e) => this.onSharedCartPOUpdate(e));
  },

  onCartUpdate(e) {
    const select = e.target;
    const product = this.utils.productData(select);
    product.list = 'Cart';
    product.cartNumber = this.cartNumber;

    trackGA('ec:addProduct', product);
    trackGA('ec:setAction', 'update');
    trackEvent({
      name: 'Cart',
      value: 'Update',
      params: product,
    });
    trackCdp({
      name: 'Update Product',
      params: {
        feature: 'shop',
        order_number: this.cartNumber,
        sku: product.sku,
      },
    });

    this.$form.submit();
  },

  onSharedCartPOUpdate(e) {
    const $invoiceTo = $('#invoice-to');
    const $businessName = $('#business-name');

    const radioValue = e.target.value === 'true';

    if (radioValue) {
      $invoiceTo.removeClass('hidden');
      $businessName.removeClass('hidden');

      $invoiceTo.find('input')[0].required = true;
    } else {
      $invoiceTo.addClass('hidden');
      $businessName.addClass('hidden');

      // Clear fields so if an invalid email is entered and then purchase order is toggled off, user can still continue
      const invoiceToInput = $invoiceTo.find('input')[0];
      invoiceToInput.required = false;
      invoiceToInput.value = '';

      $businessName.find('input')[0].value = '';
    }
  },

  onCartRemove(e) {
    e.preventDefault();

    const button = e.target;
    const product = this.utils.productData(button);
    const $lineItem = $(button).closest('.line-item');
    const $qty = $lineItem.find(this.utils.QUANTITY_SELECTOR);
    product.list = 'Cart';
    product.cartNumber = this.cartNumber;

    trackGA('ec:addProduct', product);
    trackGA('ec:setAction', 'remove');
    trackEvent({
      name: 'Cart',
      value: 'Remove',
      params: product,
    });
    trackCdp({
      name: 'Remove Product',
      params: {
        feature: 'shop',
        order_number: this.cartNumber,
        sku: product.sku,
      },
    });

    $qty.val(0);
    this.$form.submit();
  },
};
